import React from 'react';

export default function AuctionPanel({
  selectedTile,
  isSelectedTileOwnedByCurrentPlayer,
  getSelectedTileAuction,
  getAuctionTimeRemaining,
  getPlayerColor,
  getOwnerDisplayName,
  getCurrentPlayer,
  bidAmount,
  setBidAmount,
  canPlaceBid,
  placeBid,
  userId,
  isMobile
}) {
  if (!selectedTile) return null;

  const auction = getSelectedTileAuction();
  if (!auction) return null;

  const timeRemaining = getAuctionTimeRemaining(selectedTile.key);
  const elapsedTime = Math.floor((Date.now() - new Date(auction.startTime).getTime()) / 1000);
  const isInExtensionPhase = elapsedTime > 45;

  return (
    <div style={{
      position: 'absolute',
      top: isSelectedTileOwnedByCurrentPlayer() 
        ? (isMobile ? '320px' : '420px') 
        : (isMobile ? (selectedTile.owner ? '150px' : '130px') : (selectedTile.owner ? '180px' : '160px')),
      right: '10px',
      background: 'rgba(255, 87, 34, 0.9)',
      color: 'white',
      padding: '15px',
      borderRadius: '8px',
      fontFamily: 'Arial, sans-serif',
      minWidth: '250px',
      maxHeight: isSelectedTileOwnedByCurrentPlayer() 
        ? (isMobile ? 'calc(100vh - 340px)' : 'calc(100vh - 440px)') 
        : (isMobile ? 'calc(100vh - 155px)' : 'calc(100vh - 200px)'),
      overflowY: 'auto'
    }}>
      <h3 style={{ margin: '0 0 10px 0', textAlign: 'center', color: '#FFE0B2' }}>
        🔥 AUCTION ACTIVE
      </h3>
      <div style={{ fontSize: '1.1em', margin: '10px 0', textAlign: 'center', color: '#FFFFFF' }}>
        Current Bid: <span style={{ color: '#FFD700', fontWeight: 'bold' }}>
          ${auction.highestBid?.toLocaleString()}
        </span>
      </div>
      <div style={{ marginBottom: '10px', textAlign: 'center', color: '#FFFFFF' }}>
        Highest Bidder: <span style={{ 
          color: getPlayerColor(auction.highestBidder), 
          fontWeight: 'bold' 
        }}>
          {auction.highestBidderDisplayName || getOwnerDisplayName(auction.highestBidder)}
        </span>
      </div>
      <div style={{ 
        fontSize: '1.1em', 
        color: isInExtensionPhase ? '#FFD700' : (timeRemaining <= 10 ? '#FF6B6B' : '#FFD700'), 
        textAlign: 'center', 
        marginBottom: '15px', 
        fontWeight: 'bold' 
      }}>
        Time Remaining: {timeRemaining}s
        {isInExtensionPhase && timeRemaining > 15 && (
          <div style={{ fontSize: '0.7em', color: '#FFE0B2', marginTop: '5px' }}>
            (Bids now extend auction by 15s)
          </div>
        )}
      </div>
      
      {auction.highestBidder !== userId && (
        <div>
          <input
            type="number"
            value={bidAmount}
            onChange={(e) => setBidAmount(e.target.value)}
            placeholder={`Min: $${(auction.highestBid + 1000).toLocaleString()}`}
            style={{
              padding: '5px',
              marginBottom: '10px',
              borderRadius: '3px',
              border: 'none',
              width: '100%',
              fontSize: '14px'
            }}
          />
          
          <div style={{ 
            marginBottom: '10px', 
            fontSize: '0.8em',
            color: canPlaceBid() ? '#C8E6C9' : '#FFCDD2',
            textAlign: 'center'
          }}>
            Your Budget: ${getCurrentPlayer()?.budget.toLocaleString() || '0'}
          </div>
          
          {bidAmount && !canPlaceBid() && (
            <div style={{
              marginBottom: '10px',
              padding: '8px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              border: '1px solid #FFCDD2',
              borderRadius: '4px',
              fontSize: '0.8em',
              color: '#FFCDD2',
              textAlign: 'center'
            }}>
              {parseFloat(bidAmount) < (auction.highestBid + 1000) 
                ? '⚠️ Bid must be at least $1,000 higher than current bid'
                : '⚠️ Insufficient funds for this bid'}
            </div>
          )}
          
          <button 
            onClick={placeBid} 
            disabled={!canPlaceBid()}
            style={{
              padding: '8px 15px',
              backgroundColor: canPlaceBid() ? '#4CAF50' : '#666',
              color: canPlaceBid() ? 'white' : '#999',
              border: 'none',
              borderRadius: '3px',
              cursor: canPlaceBid() ? 'pointer' : 'not-allowed',
              width: '100%',
              opacity: canPlaceBid() ? 1 : 0.6,
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            {canPlaceBid() ? 'Place Bid' : 'Insufficient Funds'}
          </button>
        </div>
      )}
      
      {auction.highestBidder === userId && (
        <div style={{ 
          textAlign: 'center', 
          padding: '10px', 
          backgroundColor: 'rgba(76, 175, 80, 0.3)', 
          borderRadius: '5px',
          color: '#C8E6C9',
          border: '1px solid #4CAF50'
        }}>
          <strong>You are the highest bidder!</strong>
        </div>
      )}
    </div>
  );
}